// Copyright (C) 2021 Bystronic Laser AG

import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import { DataRetriever, ProcedureName } from '../abstract/chartGenerator';
import { metricsService } from '@/services/metrics.service';
import { BendProductionHistoryData } from '../chartsData';
import { responseHandler } from '@/services/response.handler';

export default class BendProductionHistoryRetriever extends DataRetriever<
  BendProductionHistoryData[]
> {
  constructor(procedure: ProcedureName, private customerIdDh: number) {
    super(procedure);
  }

  override async getData(
    selectedDevices: string[],
    selectedShifts: number[],
    timeSpan: FilterTimeSpanEnum | [string, string],
    timeAxisSpan?: FilterTimeAxisSpanEnum,
    params?: { [key: string]: any },
    customerNo?: string,
  ): Promise<BendProductionHistoryData[] | null> {
    const dateRange = timeSpan as [string, string];
    return await metricsService.getBendingDevicesMetrics(
      this.procedure,
      {
        customerIdDh: this.customerIdDh,
        deviceStringIds: selectedDevices,
        shiftIds: selectedShifts,
        startDate: dateRange[0],
        endDate: dateRange[1],
      },
      this.controller,
    ).then((data) => responseHandler.handleDates(data));
  }
}
